import * as types from '@store/types'
import axios from 'axios'

const actions = {
  [types.SUPPORT]: async ({ dispatch }, payload) => {
    try {
      const response = await axios.post(`support`, payload )

      if (response) {
        const feedback = {
          type: 'success',
          icon: 'paper-plane',
          title: 'Suporte',
          text: 'Solicitação de suporte enviada. Em breve você receberá um e-mail do clube.'
        }
        dispatch(types.FEEDBACK, feedback)
      }
      return response
    } catch(e) {
      const feedback = {
        text: 'Ocorreu um erro ao tentar processar a sua solicitação.',
        type: 'error',
        title: 'Ops!'
      }
      dispatch(types.FEEDBACK, feedback)

      return e.response.data.data
    }

  }
}

export default { actions }



// WEBPACK FOOTER //
// ./src/store/modules/support.js